import React from 'react';
import BaseActionForm from '../BaseActionForm';
import { Button, Dropdown } from "react-bootstrap";
import ApiService from "../../services/ApiService";
import './styles.scss'
import { useNavigate, useLocation } from 'react-router-dom'
import DropdownWithFilter from './../../components/DropdownWithFilter';
import BackArrow from './../../assets/BackArrow.svg'

export default function GeometryTransformer(props) {
    const navigation = useNavigate() // extract navigation prop here 
    const { state } = useLocation();
    return <GeometryTransformerClass {...props} dataset={props.choosenDataset ? props.choosenDataset : (state && state.params && state.params.GT_dataset)} navigation={navigation} /> //pass to your component.
}


class GeometryTransformerClass extends BaseActionForm {


    static COORD_SYSTEMS = [
        {
            epsg: 'EPSG:4326',
            name: 'WGS84',
            prettyName: 'WGS-84 (градусы)',
            proj4: '+proj=longlat +ellps=WGS84 +datum=WGS84 +no_defs',
        },
        {
            epsg: 'EPSG:3857',
            name: 'webMercatorESRI',
            prettyName: 'WebMercator',
            proj4:
                '+proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +wktext  +no_defs',
        },
        {
            epsg: 'EPSG:90631',
            name: 'MSK-63-1',
            prettyName: 'МСК-63 (зона 1)',
            proj4:
                '+proj=tmerc +lat_0=0 +lon_0=49.03333333333 +k=1 +x_0=1300000 +y_0=-5509414.69 +ellps=krass +towgs84=23.57,-140.95,-79.8,0,0.35,0.79,-0.22 +units=m +no_defs',
        },
        {
            epsg: 'EPSG:28409',
            name: 'SamObl_Transformed',
            prettyName: 'МСК Самарской области (трансформированная)',
            proj4:
                '+proj=tmerc +lat_0=0 +lon_0=51 +k=1 +x_0=9601000 +y_0=101000 +ellps=krass +towgs84=23.9,-141.3,-80.9,0,0.37,0.85,-0.12 +units=m +no_defs',
        },
        {
            epsg: "EPSG:9000001",
            name: "Khabarovsk",
            prettyName: "МСК Хабаровск",
            proj4: "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=00 +y_0=-5355646 +s11=1.0000048127181109 +s12=-0.00000289490451149681 +xoff=-40.04939298 +s21=0.0000028949045114968119 +s22=1.0000048127181109 +yoff=-0.9124239683 +ellps=krass +towgs84=23.9,-141.3,-80.9,0,0.37,0.85,-0.12 +units=m +no_defs"
        },
        {
            epsg: "EPSG:100000",
            name: "SK_50_Moscow_zone_2",
            prettyName: "МСК-50 Зона 2",
            proj4: "+proj=tmerc +lat_0=0 +lon_0=38.48333333333 +k=1 +x_0=2250000 +y_0=-5712900.566 +ellps=krass +towgs84=23.57,-140.95,-79.8,0,0.35,0.79,-0.22 +units=m +no_defs"
        },
        {
            epsg: "EPSG:141001",
            name: "MSK_41_zone1",
            prettyName: "МСК-41 Зона 1",
            proj4: "+proj=tmerc +lat_0=0 +lon_0=158.46666666667 +k=1 +x_0=1400000 +y_0=-5316586.442 +ellps=krass +towgs84=23.57,-140.95,-79.8,0,0.35,0.79,-0.22 +units=m +no_defs"
        }
    ];


    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            myDatasets: null,
            dataset: null,
            inputType: null,
            columnX: null,
            columnY: null,
            columnWKT: null,
            coordSystemProj4: null,
            processResult: null,
            onErrorWithProcesses: false
        }
    }

    async componentDidMount() {
        super.componentDidMount();

        this.startLoading();
        let response = await Promise.all([
            ApiService.getMyDatasets()
        ]);
        this.stopLoading();
        if (this.checkStatus(response)) {
            this.setState({
                myDatasets: response[0].datasets
            }, () => {
                this.props.dataset && this.handleDatasetSelect(this.props.dataset)
            });
        }
    }

    handleDatasetSelect = (dataset) => {
        this.setState(
            {
                dataset: dataset,
                inputType: null,
                columnX: null,
                columnY: null,
                columnWKT: null
            }, () => {
                if (dataset && ApiService.checkActiveProcess(dataset, 'lk_geometrytransformer')) {
                    this.setState({ onErrorWithProcesses: true })
                }
                this.datasetProcessCheck(dataset)
            }
        );
    }

    updateAndCheckDataset = (dataset) => {
        if (dataset) {
            ApiService.getMyDatasets().then((response) => {
                if (this.checkStatus(response)) {

                    response.datasets.forEach((newDataset) => {
                        if (newDataset._id["$oid"] === dataset._id["$oid"]) {
                            this.setState({
                                dataset: newDataset,
                                onErrorWithProcesses: ApiService.checkActiveProcess(newDataset, 'lk_geometrytransformer')
                            });
                        }
                    })
                }

                this.stopLoading();
            });
        }
    }
    datasetProcessCheck = (dataset) => {
        this.checkInterval && clearInterval(this.checkInterval);
        if (dataset) {
            this.checkInterval = setInterval(() => {
                this.startLoading();
                this.updateAndCheckDataset(dataset)
            }, 5000);
        }
    }


    onStartProcess = () => {
        if (this.state.dataset && !this.state.onErrorWithProcesses && (
            (
                ((this.state.inputType === "TWO_COLUMNS") && this.state.columnX && this.state.columnY)
                ||
                ((this.state.inputType === "WKT_COLUMN") && this.state.columnWKT)
            )
        )) {
            ApiService.createLKGeometryTransformerTask(this.state.dataset.dataset, this.state.inputType,
                (this.state.columnX ? this.state.columnX.name : null),
                (this.state.columnY ? this.state.columnY.name : null),
                (this.state.columnWKT ? this.state.columnWKT.name : null),
                (this.state.coordSystemProj4 ? this.state.coordSystemProj4.proj4 : null)).then((response) => {
                    this.setState({ processResult: response, onErrorWithProcesses: true });
                    setTimeout(() => { this.setState({ processResult: null }) }, 5000);
                });
        }
    };


    render() {

        let INPUT_TYPES = {
            TWO_COLUMNS: "Колонки X и Y",
            WKT_COLUMN: "Колонка с WKT"
        };

        return (
            <div className='twoHalfs'>
                <div id={"geometryTransformer"} className={"flexColumn rightPanel"}>
                    {this.renderAlerts()}


                    <div className="headerContainer">
                        {this.props && !this.props.dataset && <img src={BackArrow} className='backArrow' alt='back arrow' onClick={() => this.props.navigation(-1)} />}
                        <div className='titleContainer'><p className="headerMargin">Трансформация геометрии</p></div>
                    </div>

                    {this.props && this.props.dataset && <div className="bottomHeaderContainer">
                        <p>{this.props.dataset.name}</p>
                    </div>}



                    <div className="postHeaderContainer textRoboto infoContainer">
                        {this.state.myDatasets && !this.props.dataset &&
                            <>
                                <p className="textBottom">Hабор данных</p>
                                <DropdownWithFilter
                                    className="dropSelectDataset"
                                    items={this.state.myDatasets}
                                    selectedItem={this.state.dataset}
                                    onItemClick={(item) => { this.handleDatasetSelect(item) }}
                                    label={(item) => { return item.name || "(не установлено)"; }}
                                    defaultLabel={"Bыберите"}
                                />
                            </>
                        }
                        <div className='flexColumn'>
                            {
                                this.state.dataset &&
                                <Dropdown className="dropGeometryTransformer">
                                    <Dropdown.Toggle className="dropdownButtonGeometryTransformer" variant="success" id="dropdown-basic">
                                        {this.state.inputType ? INPUT_TYPES[this.state.inputType] : "Выберите тип исходных данных"}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        {Object.entries(INPUT_TYPES).map((typeArray, index2) => (
                                            <Dropdown.Item key={index2} onClick={() => {
                                                this.setState({ inputType: typeArray[0] });
                                            }}>{typeArray[1]}</Dropdown.Item>
                                        ))}
                                    </Dropdown.Menu>
                                </Dropdown>
                            }


                            {this.state.dataset && (this.state.inputType === "TWO_COLUMNS") &&
                                <div style={{marginLeft: '20px'}}>
                                    <Dropdown className="dropGeometryTransformer">
                                        <Dropdown.Toggle className="dropdownButtonGeometryTransformerLite" variant="success" id="dropdown-basic">
                                            {this.state.columnX ? this.state.columnX.caption : "Выберите колонку X"}
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            {this.state.dataset.fields.map((field, index2) => (
                                                <Dropdown.Item key={index2} onClick={() => {
                                                    this.setState({ columnX: field });
                                                }}>{field.caption}</Dropdown.Item>
                                            ))}
                                        </Dropdown.Menu>
                                    </Dropdown>

                                    <Dropdown className="dropGeometryTransformer">
                                        <Dropdown.Toggle className="dropdownButtonGeometryTransformerLite" variant="success" id="dropdown-basic">
                                            {this.state.columnY ? this.state.columnY.caption : "Выберите колонку Y"}
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            {this.state.dataset.fields.map((field, index2) => (
                                                <Dropdown.Item key={index2} onClick={() => {
                                                    this.setState({ columnY: field });
                                                }}>{field.caption}</Dropdown.Item>
                                            ))}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                            }

                            {this.state.dataset && (this.state.inputType === "WKT_COLUMN") &&
                                <Dropdown className="dropGeometryTransformer">
                                    <Dropdown.Toggle className="dropdownButtonGeometryTransformer" variant="success" id="dropdown-basic">
                                        {this.state.columnWKT ? this.state.columnWKT.caption : "Выберите колонку WKT"}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        {this.state.dataset.fields.map((field, index2) => (
                                            <Dropdown.Item key={index2} onClick={() => {
                                                this.setState({ columnWKT: field });
                                            }}>{field.caption}</Dropdown.Item>
                                        ))}
                                    </Dropdown.Menu>
                                </Dropdown>
                            }
                        </div>


                        {this.state.dataset &&
                            <Dropdown className="dropGeometryTransformer">
                                <Dropdown.Toggle className="dropdownButtonGeometryTransformer" variant="success" id="dropdown-basic">
                                    {this.state.coordSystemProj4 ? this.state.coordSystemProj4.prettyName : "Выберите СК исходных данных"}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    {GeometryTransformerClass.COORD_SYSTEMS.map((coordSystem, index2) => (
                                        <Dropdown.Item key={index2} onClick={() => {
                                            this.setState({ coordSystemProj4: coordSystem });
                                        }}>{coordSystem.prettyName}</Dropdown.Item>
                                    ))}
                                    <Dropdown.Item onClick={() => {
                                        this.setState({ coordSystemProj4: null });
                                    }}>Никакая не выбрана</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        }
                    </div>
                    {
                    (this.state.processResult)
                        ?
                        <div className='textBottom'>
                            {this.state.processResult && (this.state.processResult.status === "success")
                                ?
                                <div>
                                    <p className='textImportBottom'>Разбор геометрии запущен</p>
                                </div>
                                :
                                <p className='textImportBottom'>Произошла ошибка: {this.state.processResult.errorMessageRu}</p>
                            }
                        </div>
                        :
                        (((this.state.inputType === "TWO_COLUMNS") && this.state.columnX && this.state.columnY) || ((this.state.inputType === "WKT_COLUMN") && this.state.columnWKT)) &&
                        <Button variant="primary" className="applyInstrument" style={this.state.onErrorWithProcesses ? {opacity: '0.3', pointerEvents: 'none'} : {opacity: '1'}} onClick={this.onStartProcess}>Запустить разбор геометрии</Button>
                }
                    <p className={'infoProcesses'} style={this.state.onErrorWithProcesses ? {display: 'inline'} : {display: 'none'}}> Дождитесь завершения запущеных процессов </p>

                    {this.state.message}
                </div>


                <div className='rightHalf'></div>
            </div>
        );
    }
}















